import React, { useState, useEffect, useRef, useMemo } from "react";
import numberToWords from "number-to-words";
import styled from 'styled-components'
import '../../../assets/styles/admin/quotation_print.scss'
import { AnyARecord } from "dns";
import { string } from "prop-types";
import { Button, Descriptions, Radio } from 'antd';
import moment from "moment";
interface Props {
    data?: any;
    payment?: any;
    refPrint?: any;
}

const Print: React.FC<Props> = ({ data, payment, refPrint }) => {
    const NumberFormat = (number: number) => {
        return new Intl.NumberFormat().format(number)
    }
    const amount = data?.treatments?.reduce((total: number, item: any) => {
        return total + (item?.price * item?.quantity)
    }, 0) || 0;
    const discount = data?.treatments?.reduce((total: number, item: any) => {
        return total + parseInt(item?.discount)
    }, 0) || 0;

    const BAHTTEXT: string | any = (num: number | string, suffix: string) => {
        if (typeof suffix === 'undefined') {
            suffix = 'บาทถ้วน';
        }
        num = num || 0;
        let StrNum = num.toString().replace(/[, ]/g, '');
        if (isNaN(parseFloat(StrNum)) || (Math.round(parseFloat(StrNum) * 100) / 100) === 0) {
            return 'ศูนย์บาทถ้วน';
        } else {
            var t = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'],
                n = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'],
                len,
                digit,
                text = '',
                parts: string[] | any,
                i;

            if (StrNum.indexOf('.') > -1) {

                parts = StrNum.toString().split('.');

                num = parts[0];
                parts[1] = parseFloat('0.' + parts[1]);
                parts[1] = (Math.round(parts[1] * 100) / 100).toString(); // more accurate than toFixed(2)
                parts = parts[1].split('.');

                if (parts.length > 1 && parts[1].length === 1) {
                    parts[1] = parts[1].toString() + '0';
                }

                num = parseInt(num.toString(), 10) + parseInt(parts[0], 10);

                text = num ? BAHTTEXT(num) : '';

                if (parseInt(parts[1], 10) > 0) {
                    text = text.replace('ถ้วน', '') + BAHTTEXT(parts[1], 'สตางค์');
                }
                return text;
            } else {
                if (StrNum.length > 7) {
                    var overflow = StrNum.substring(0, StrNum.length - 6);
                    var remains = StrNum.slice(-6);
                    return BAHTTEXT(overflow).replace('บาทถ้วน', 'ล้าน') + BAHTTEXT(remains).replace('ศูนย์', '');

                } else {

                    len = StrNum.length;
                    for (i = 0; i < len; i = i + 1) {
                        digit = parseInt(StrNum.charAt(i), 10);
                        if (digit > 0) {
                            if (len > 2 && i === len - 1 && digit === 1 && suffix !== 'สตางค์') {
                                text += 'เอ็ด' + t[len - 1 - i];
                            } else {
                                text += n[digit] + t[len - 1 - i];
                            }
                        }
                    }
                    text = text.replace('หนึ่งสิบ', 'สิบ');
                    text = text.replace('สองสิบ', 'ยี่สิบ');
                    text = text.replace('สิบหนึ่ง', 'สิบเอ็ด');

                    return text + suffix;
                }
            }
        }
    }
    const TablePrint = styled.table`
        font-family: Sarabun;
        border-collapse: collapse;
        width: 100%;
        margin-bottom: 1.2rem;
        tbody {
            border: 1px solid rgb(91, 174, 169) !important;
          }
          
          td,
          th {
            border-right: 1px solid rgb(91, 174, 169) !important;
            border-left: 1px solid rgb(91, 174, 169) !important;
            text-align: center;
            padding: 8px;
            &:nth-child(odd) {

            }
          }
        .b-r-0 {
            border-right: 0 !important;
        }
        .b-l-0 {
            border-left: 0 !important;
        }
    `
    const PrintCss = styled.div`
    .page-print  {
        // width: 21cm;
        min-height: 29.7cm;
        table {
            font-size: 13px !important;
            td{ 
                font-size: 13px !important;
            }
        }
    }
    p {
        font-size: 13px !important;
    }
    .report-info {
        padding: 15px 15px;
    }
    @page {
        size: A4 portrait;
        margin: 0;
    }
    @media print {
        p {
            font-size: 13px !important;
        }
        .page-print {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            min-height: initial;
            box-shadow: initial;
            background: initial;
            page-break-after: always;
            zoom: 80%
            // transform: scale(0.5);
        }
        .report-header{
            .logo {
                margin-bottom: 1rem;
            }
        }
        .report-info {
            padding: 15px 15px;
        }
        .report-body {
            padding: 15px 15px;
            table {
                font-size: 13px !important;
                td{ 
                    font-size: 13px !important;
                }
            }
        }
    }
    `


    return (
        <PrintCss
            ref={refPrint}
            style={{
                padding: '1rem',
                background: '#ffff',
                borderRadius: '1rem'
            }}>
            <div className="page-print">
                <div className="report-header">
                    <div style={{
                        display: 'flex'
                    }}>
                        <div style={{
                            width: '70%',
                            maxWidth: '70%'
                        }}>
                            <div className="logo text-left">
                                <img src="data:image/png;base64,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" className="logo" />
                            </div>
                            <p className="bold">บริษัท เดอมาสเตอร์ จำกัด 342/1, 342/2 ซอยสุขุมวิท 63 (เอกมัย) แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพ ฯ 10110</p>
                            <p className="bold">โทร 02-714-4471 แฟกซ์ 02-714-4001 เลขประจำตัวผู้เสียภาษี 01055554026949</p>
                            <p>Dermaster Company Limited42 Ekamai Rd, Klongton Nua, Wattana, Bangkok, Thailand 10110</p>
                            <p>Tel. +662 71-444-71 Fax. +662-714-4001 Tax ID No. {data?.taxCode}</p>
                            <p></p>
                        </div>
                        <div style={{
                            width: '30%',
                            maxWidth: '30%',
                            height: 'max-content',
                            margin: 0,
                            display: 'grid',
                            justifyItems: 'end'
                        }}>
                            <div style={{
                                width: '70%',
                                textAlign: 'center',
                                border: '1px solid rgb(91, 174, 169)',
                                padding: '10px 25px',
                                borderRadius: '8px'
                            }}>
                                <p>ต้นฉบับใบกำกับภาษี</p>
                                <p>Original Tax Invoice</p>
                            </div>
                            <div style={{
                                marginTop: '20px',
                                textAlign: 'center'
                            }}>
                                <p>วันที่/Date : {moment().format("DD/MM/YYYY")}</p>
                                <p>ใบแจ้งหนี้เลขที่/Tax Invoice No.</p>
                                <p>{data?.taxCode}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="report-info">
                    <div style={{
                        display: 'flex'
                    }}>
                        <div style={{
                            width: '50%',
                            maxWidth: '50%'
                        }}>
                            <p>ลูกค้า/Customer : {data?.customer}</p>
                            <p>รหัสลูกค้า/CN : {data?.customerCode}</p>
                            <p>เลขที่ใบยา/Ref. : {data?.vn}</p>
                            <p>ผู้ขาย/Consult : {data?.consults?.map((item: any) => <span>{item?.displayName} , </span>)}</p>
                        </div>
                        <div style={{
                            width: '50%',
                            maxWidth: '50%',
                            height: 'max-content',
                            margin: 0,
                            display: 'grid',
                        }}>
                            <p>ที่อยู่ออกบิล/Billing Address :</p>
                            <p> {data?.billingAddress}</p>
                        </div>
                    </div>
                </div>
                <div className="report-body">
                    <TablePrint>
                        <tr style={{
                            border: '1px solid rgb(91, 174, 169)'
                        }}>
                            <th>ลำดับที่/No.</th>
                            <th>รายการ/Description</th>
                            <th>จำนวนเงิน/Amount</th>
                        </tr>
                        {data?.items?.map((item: any, index: number) =>
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{textAlign: 'left'}}>{item?.name}</td>
                                <td style={{textAlign: 'right'}}>{NumberFormat(item.totalPrice)}</td>
                            </tr>
                        )}
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>

                        <tr style={{
                            position: 'relative',
                            borderTop: '1px solid rgb(91, 174, 169)'
                        }}>
                            <th colSpan={1} rowSpan={4} style={{
                                textAlign: 'left',
                                padding: '1rem',
                                verticalAlign: 'top',
                                borderBottom: '1px solid rgb(91, 174, 169)',
                            }}
                                className="b-r-0">
                                <div>
                                    <p>หมายเหตุ : {data?.note}</p>
                                </div>

                            </th>
                            <td style={{
                                textAlign: "right",
                                border: '0!important',
                                borderLeft: '0!important'
                            }}
                                className="b-l-0">ราคาก่อนภาษีมูลค่าเพิ่ม
                                Price  Without VAT</td>
                            <td style={{textAlign: 'right'}}>{NumberFormat((data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0)) - (data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0) * (7 / 100)))}</td>
                        </tr>
                        <tr>
                            <td style={{
                                textAlign: "right",
                                border: '0 !important'

                            }}
                                className="b-l-0">ภาษีมูลค่าเพิ่ม 7%
                                Vat 7%</td>
                            <td style={{textAlign: 'right'}}>{NumberFormat((data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0) * (7 / 100)))}</td>
                        </tr>
                        <tr>
                            <td style={{
                                textAlign: "right",
                                borderTop: '0 !important',
                                borderLeft: '0 !important',
                                borderBottom: '1px solid rgb(91, 174, 169)'
                            }}
                                className="b-l-0">รวมทั้งสิ้น
                                Grand Total</td>
                            <td style={{
                                borderTop: '0 !important',
                                borderLeft: '0 !important',
                                borderBottom: '1px solid rgb(91, 174, 169)',
                                textAlign: 'right'
                            }}>{NumberFormat((data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0)))}</td>
                        </tr>
                    </TablePrint>
                </div>
                <div className="report-detail">

                    <div className="info">
                        <div style={{
                            display: 'flex'
                        }}>
                            <div style={{
                                width: '100%',
                                maxWidth: '70%'
                            }}>
                                <p>{BAHTTEXT(NumberFormat((data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0))))} ({numberToWords.toWordsOrdinal((data?.items?.reduce((total: number, item: any) => total + item.totalPrice, 0)) || 0)} baht only)</p>
                            </div>
                            <div style={{
                                width: '100%',
                                maxWidth: '30%',
                                height: 'max-content',
                                margin: 0,
                                display: 'grid',
                            }}>

                            </div>
                        </div>

                        <hr style={{
                            borderBottom: '1px solid rgb(91, 174, 169)'
                        }} />

                        <ul style={{ fontSize: '0.8rem' }}>
                            <li>บริษัทจะรับคืนยาเฉพาะรายการที่มีอาการแพ้ยาซึ่งวินิจฉัยโดยแพทย์เท่านั้น กรุณาเก็บใบเสร็จเป็นหลักฐานในการติดต่อกับบริษัททุกครั้ง
                                Patients may return the medicine only if they have experienced adverse reaction to that medication. Please keep this receipt for reference.
                            </li>
                            <li>
                                ได้รับสินค้า/บริการ ถูกต้องและอยู่ในสภาพเรียบร้อยทุกประการ หากรายการไม่ถูกต้องโปรดทักท้วงทันที ในกรณีที่ไม่มีการทักท้วง บริษัทขอสงวนสิทธิ์ตามรายการดังกล่าวข้างต้น
                                Receive the above Goods/Services in Good Order and Condition. If the above item are incorrect please return/report the said incorrect goods/item within the day. If the customer don’t
                                return/report any incorrect goods/item within a day of purchased, the company reserve the right to refuse change of item or modify services.
                            </li>
                            <li>
                                เพื่อเป็นการประกันคุณภาพของยาที่จ่ายให้แก่ลูกค้า บริษัทขอสงวนสิทธิ์ไม่รับเปลี่ยนยา หรือรับคืนยา
                                For pharmaceutical quality assurance, Company cannot provide return or accept any returned medication.
                            </li>
                            <li>
                                ในกรณียกเลิก/เปลี่ยนแปลง/โอนสิทธิ์/คืนเงิน บริษัทฯ ขอสงวนสิทธิ์ให้ถือปฏิบัติตามเงื่อนไขที่บริษัทฯ กำหนดไว้เท่านั้น ในกรณียกเลิกคอร์ส/Package ไม่สามารถคืนเป็นเงินสดได้แต่สามารถเปลี่ยนคอร์สได้
                                In case of cancellation / change / transfer / refund, the patient must abide by the terms & conditions of the Company. In addition in case of treatment course cancellation, the company
                                will not refund cash but the customer can change to another treatment.
                            </li>
                        </ul>

                        <div style={{
                            width: '100%',
                            display: 'flex'
                        }}>
                            <div style={{
                                width: '50%'
                            }}
                                className="center">
                                <p className="center">____________________________________________</p>
                                <p>ชื่อลูกค้า (Customer Signature)</p>
                            </div>
                            <div style={{
                                width: '50%'
                            }}
                                className="center">
                                <p className="center">____________________________________________</p>
                                <p>( {payment?.createdUser?.displayName} )</p>
                                <p>เจ้าหน้าที่การเงิน (Cashier)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PrintCss >
    );
};
export default Print;
